import script from "./VenueDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueDetails.vue?vue&type=script&setup=true&lang=js"

import "./VenueDetails.vue?vue&type=style&index=0&id=1af67196&lang=css"

const __exports__ = script;

export default __exports__